import { ManageExportSetDefinitionsService } from '@api-client/export-center';
import { createPaginationEntity } from '@luna/api';

import { queryExportSetById } from './queryExportSetById';
import { queryExportSetsPage } from './queryExportSetsPage';

const {
    useEntities: useMetadataExportsSets,
    useEntity: useMetadataExportSet,
    useEntityCreate: useCreateExportSet,
    useEntityUpdate: useUpdateExportSet,
    useEntityDelete: useDeleteExportSet,
    entityHelpers: {
        invalidateAll: invalidateMetadataExportsSets,
        invalidateLists: invalidateMetadataExportsSetsLists,
    },
} = createPaginationEntity({
    name: 'exports/sets/metadata',
    payloadCreators: {
        queryPage: queryExportSetsPage,
        queryById: queryExportSetById,
        create: ManageExportSetDefinitionsService.postPublicExportSets,
        updateById: ManageExportSetDefinitionsService.putPublicExportSets,
        deleteById: ManageExportSetDefinitionsService.deletePublicExportSets,
    },
});

export {
    useMetadataExportsSets,
    useMetadataExportSet,
    invalidateMetadataExportsSets,
    invalidateMetadataExportsSetsLists,
    useCreateExportSet,
    useUpdateExportSet,
    useDeleteExportSet,
};
